import { useGtm } from '@gtm-support/vue-gtm';

/** Globally fetch user details */
export default defineNuxtPlugin({
  name: 'user-fetch',
  dependsOn: ['keycloak', 'gtm'],
  async setup() {
    // Fetch user on loading to avoid app flickering
    const userStore = useUserStore();
    const { user } = storeToRefs(userStore);
    const gtm = useGtm();

    watch(user, (newUser) => {
      if (!newUser) return;
      gtm?.push({
        event: 'user_identified',
        userId: newUser?.id,
      });
    });

    await userStore.fetchUser();

    // Do this if using SSR to avoid hydration mismatch.
    // nuxtApp.hook('app:mounted', () => {
    //   await useUserStore().fetchUser();
    // });
  },
});
